export default __webpack_public_path__ + "static/probierpaket-fa50dc2159fc7e3844288d6efdba532c.jpg";